module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/bago2023',
    profileColor: {saturation: 80, brightness: 70},
    favicon: '/bagofavicon.ico',
    defaultPassword: 'default'
}